export default __webpack_public_path__ + "static/media/yahoo.6c49c0ff.svg";